import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApplicationLogService } from '../services/application-log.service';
import { takeUntil } from 'rxjs/operators';
import { ApplicationLog } from '../interfaces/application-log.interface';
import { showErrorSwal } from '@asamco/utils';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoSelectionModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shell-application-logs-overview',
    templateUrl: './application-logs-overview.component.html',
    styleUrls: ['../styles/alert.scss', '../styles/tile-style.scss', './application-logs-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, DxDataGridModule, DxoSelectionModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule, AsyncPipe]
})
export class ApplicationLogsOverviewComponent implements OnInit, OnDestroy {
  public listSubject: BehaviorSubject<ApplicationLog[]> = new BehaviorSubject<ApplicationLog[]>(null);
  public listObservable: Observable<ApplicationLog[]> = this.listSubject.asObservable();

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef, private als: ApplicationLogService) { }

  ngOnInit(): void {
    this.als.get()
      .pipe(takeUntil(this.destroy$),
    ).subscribe({next: logs => {
        this.listSubject.next(logs);
        this.cdr.detectChanges();
      }, error: showErrorSwal
    })
  }

  copyContents(d) {
    (<any>navigator).clipboard.writeText(d.value);
  }

  onRowPrepared(e: any) {
    e.rowElement.style.whiteSpace = 'nowrap';
	}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
